/* FizzyIQ — Interactive ingredient synergy explorer (se-). Toggle ingredients →
   render a constellation of selected nodes with documented-synergy links, a
   "together vs on their own" comparison, and live synergy callouts. Data is the
   inline JSON (#seData). No product claims; together-vs-alone is illustrative.
   Sam: 2026-06-28. */
(function () {
  'use strict';
  var SVGNS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs) { var e = document.createElementNS(SVGNS, tag); if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }

  function init() {
    var root = document.querySelector('.se');
    if (!root) return;
    var dataEl = root.querySelector('#seData');
    if (!dataEl) return;
    var DATA; try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var fams = DATA.families, ings = DATA.ingredients, syns = DATA.synergies;
    var byId = {}; ings.forEach(function (i) { byId[i.id] = i; });
    var selected = Object.create(null);

    var groupsEl = root.querySelector('#seGroups');
    var linksEl = root.querySelector('#seLinks');
    var nodesEl = root.querySelector('#seNodes');
    var aloneFill = root.querySelector('#seAloneFill');
    var togetherFill = root.querySelector('#seTogetherFill');
    var readoutEl = root.querySelector('#seReadout');
    if (!groupsEl || !linksEl || !nodesEl) return;

    /* ── build the chip groups by family ── */
    ['vitamin', 'mineral', 'amino', 'antiox'].forEach(function (fk) {
      var fam = fams[fk]; if (!fam) return;
      var groupIngs = ings.filter(function (i) { return i.family === fk; });
      if (!groupIngs.length) return;
      var g = document.createElement('div'); g.className = 'se-group'; g.style.setProperty('--fam', fam.color);
      var lbl = document.createElement('p'); lbl.className = 'se-group-label';
      lbl.innerHTML = '<span class="se-group-swatch"></span>' + fam.label;
      g.appendChild(lbl);
      var chips = document.createElement('div'); chips.className = 'se-chips';
      groupIngs.forEach(function (ing) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'se-chip'; b.setAttribute('aria-pressed', 'false');
        b.setAttribute('data-id', ing.id); b.style.setProperty('--fam', fam.color);
        var icon = ing.img
          ? '<span class="se-chip-img" aria-hidden="true"><img src="' + ing.img + '" alt="" loading="lazy"></span>'
          : '<span class="se-chip-bullet" aria-hidden="true"></span>';
        b.innerHTML = icon + ing.name;
        b.addEventListener('click', function () { toggle(ing.id); });
        chips.appendChild(b);
      });
      g.appendChild(chips); groupsEl.appendChild(g);
    });

    function toggle(id) { if (selected[id]) delete selected[id]; else selected[id] = true; render(); }
    var allBtn = root.querySelector('[data-se-all]'), noneBtn = root.querySelector('[data-se-none]');
    if (allBtn) allBtn.addEventListener('click', function () { ings.forEach(function (i) { selected[i.id] = true; }); render(); });
    if (noneBtn) noneBtn.addEventListener('click', function () { selected = Object.create(null); render(); });

    function selIds() { return ings.map(function (i) { return i.id; }).filter(function (id) { return selected[id]; }); }
    function activeSyns(sel) { var on = {}; sel.forEach(function (s) { on[s] = 1; }); return syns.filter(function (sy) { return on[sy.a] && on[sy.b]; }); }

    var CX = 260, CY = 178;

    function render() {
      var sel = selIds();
      root.querySelectorAll('.se-chip').forEach(function (b) { b.setAttribute('aria-pressed', selected[b.getAttribute('data-id')] ? 'true' : 'false'); });
      var active = activeSyns(sel);

      /* together-vs-alone bars (illustrative) */
      var alonePct = Math.min(sel.length / ings.length * 62, 62);
      var bonus = Math.min(active.length * 4.5, 38);
      var togetherPct = Math.min(alonePct + bonus, 100);
      aloneFill.style.width = alonePct.toFixed(1) + '%';
      togetherFill.style.width = togetherPct.toFixed(1) + '%';

      /* graph */
      while (nodesEl.firstChild) nodesEl.removeChild(nodesEl.firstChild);
      while (linksEl.firstChild) linksEl.removeChild(linksEl.firstChild);
      var pos = {};
      if (!sel.length) {
        var hint = el('text', { x: CX, y: CY, class: 'se-graph-hint' });
        hint.textContent = 'Toggle ingredients to see them combine';
        nodesEl.appendChild(hint);
      } else if (sel.length === 1) {
        pos[sel[0]] = { x: CX, y: CY, ang: 0 };
      } else {
        var R = Math.min(135, 56 + sel.length * 7);
        sel.forEach(function (id, idx) {
          var ang = (-90 + idx * 360 / sel.length) * Math.PI / 180;
          pos[id] = { x: CX + R * Math.cos(ang), y: CY + R * Math.sin(ang), ang: ang };
        });
      }

      active.forEach(function (sy) {
        var p1 = pos[sy.a], p2 = pos[sy.b]; if (!p1 || !p2) return;
        var ln = el('line', {
          x1: p1.x.toFixed(1), y1: p1.y.toFixed(1), x2: p2.x.toFixed(1), y2: p2.y.toFixed(1),
          class: 'se-link is-on' + (sy.key ? ' is-key' : ''),
          stroke: sy.key ? '#5B8DEF' : 'rgba(231,234,238,0.5)',
          'stroke-width': sy.key ? '3' : '1.8'
        });
        linksEl.appendChild(ln);
      });

      sel.forEach(function (id) {
        var p = pos[id]; if (!p) return;
        var ing = byId[id], col = fams[ing.family].color;
        var inSyn = active.some(function (sy) { return sy.a === id || sy.b === id; });
        var c = el('circle', { cx: p.x.toFixed(1), cy: p.y.toFixed(1), r: inSyn ? '8' : '6.5', class: 'se-node-dot', fill: col });
        if (inSyn) c.setAttribute('style', 'filter:drop-shadow(0 0 6px ' + col + ')');
        var ttl = el('title'); ttl.textContent = ing.name + ' — ' + ing.solo; c.appendChild(ttl);
        nodesEl.appendChild(c);
        if (sel.length <= 8) {
          var lx = p.x, ly = p.y - 14, anchor = 'middle';
          if (sel.length > 1) {
            var cos = Math.cos(p.ang), sin = Math.sin(p.ang);
            lx = p.x + cos * 15; ly = p.y + sin * 15 + 4;
            anchor = cos > 0.3 ? 'start' : (cos < -0.3 ? 'end' : 'middle');
          }
          var tx = el('text', { x: lx.toFixed(1), y: ly.toFixed(1), class: 'se-node-label', 'text-anchor': anchor });
          tx.textContent = ing.name;
          nodesEl.appendChild(tx);
        }
      });

      /* readout */
      while (readoutEl.firstChild) readoutEl.removeChild(readoutEl.firstChild);
      if (!sel.length) {
        var em = document.createElement('p'); em.className = 'se-empty';
        em.textContent = 'Pick a few ingredients to see how they work together — and what each does on its own.';
        readoutEl.appendChild(em);
      } else if (active.length) {
        active.slice().sort(function (a, b) { return (b.key ? 1 : 0) - (a.key ? 1 : 0); }).forEach(function (sy) {
          var d = document.createElement('div'); d.className = 'se-syn' + (sy.key ? ' se-syn--key' : '');
          var pair = document.createElement('span'); pair.className = 'se-syn-pair'; pair.textContent = byId[sy.a].name + ' + ' + byId[sy.b].name;
          var note = document.createElement('span'); note.className = 'se-syn-note'; note.textContent = sy.note;
          d.appendChild(pair); d.appendChild(note); readoutEl.appendChild(d);
        });
      } else {
        if (sel.length > 1) {
          var p0 = document.createElement('p'); p0.className = 'se-empty';
          p0.textContent = 'No documented direct synergy between these — but each still pulls its weight on its own:';
          readoutEl.appendChild(p0);
        }
        sel.forEach(function (id) {
          var sln = document.createElement('p'); sln.className = 'se-solo';
          sln.innerHTML = '<b></b> — ';
          sln.querySelector('b').textContent = byId[id].name;
          sln.appendChild(document.createTextNode(byId[id].solo));
          readoutEl.appendChild(sln);
        });
      }
    }

    /* default: the flagship L-theanine+caffeine pair + the B6/folate/B12 methylation
       trio, so it opens already showing two distinct documented synergy clusters */
    ['theanine', 'caffeine', 'b6', 'folate', 'b12'].forEach(function (id) { if (byId[id]) selected[id] = true; });
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
